export default {"src":"/_next/static/media/caller_modal_icon.7cd9cda0.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};